export default {
      id: "268,4_cm_=_35_+_80_+_35_+_80_+_35-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#268,4_cm_=_35_+_80_+_35_+_80_+_35",
      toString: function () {
        return this.url;
      }
    }